var _defs, _g, _g2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect, _g3, _g4, _path, _path2, _path3, _g5, _g6, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _rect2, _g7, _g8, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF2SpotTheDifference(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    viewBox: "0 0 320 790",
    role: "img",
    "aria-label": "Two players one garment apart are confused by a single misread hat; three garments apart, the same misread still names the right person.",
    fontFamily: "'Lucida Sans','Lucida Grande','Lucida Sans Unicode',Geneva,Verdana,sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f2blur",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  })))), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 10,
    fill: "#fff",
    fillOpacity: 0.6,
    style: {
      fontSize: 10,
      letterSpacing: "0.09em"
    }
  }, "THE OBVIOUS WAY"), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 10,
    textAnchor: "end",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fontSize: 10
    }
  }, "one garment apart"), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tomTop"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 44,
    height: 11,
    rx: 3,
    fill: "#4F7468"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#2E2E2E",
    stroke: "#fff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 57,
    width: 56,
    height: 52,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 57,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 57,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 80,
    width: 17,
    height: 12,
    rx: 2,
    fill: "#AAC634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 110,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 110,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 22,
    width: 44,
    height: 11,
    rx: 3,
    fill: "#2D5170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 33,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#2E2E2E",
    stroke: "#fff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 57,
    width: 56,
    height: 52,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 57,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 57,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 80,
    width: 17,
    height: 12,
    rx: 2,
    fill: "#AAC634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 110,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 110,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 180,
    textAnchor: "middle",
    fill: "#fff",
    style: {
      fontSize: 13
    }
  }, "Tom"), /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 180,
    textAnchor: "middle",
    fill: "#fff",
    style: {
      fontSize: 13
    }
  }, "Gaby"), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "10.5px"
    }
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 198,
    fill: "#fff"
  }, "hat green")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 211,
    fill: "#fff",
    fillOpacity: 0.75
  }, "t-shirt purple")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 224,
    fill: "#fff",
    fillOpacity: 0.75
  }, "armband lime")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 237,
    fill: "#fff",
    fillOpacity: 0.75
  }, "trousers off-white")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 198,
    fill: "#fff"
  }, "hat navy")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 211,
    fill: "#fff",
    fillOpacity: 0.75
  }, "t-shirt purple")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 224,
    fill: "#fff",
    fillOpacity: 0.75
  }, "armband lime")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 237,
    fill: "#fff",
    fillOpacity: 0.75
  }, "trousers off-white"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 252,
    width: 104,
    height: 86,
    rx: 3,
    fill: "#0B0B0B",
    stroke: "#fff",
    strokeOpacity: 0.18
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tomTop",
    xlinkHref: "#tomTop",
    filter: "url(#f2blur)",
    transform: "translate(32.7 250) scale(0.46)"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 332,
    textAnchor: "middle",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fontSize: "9.5px"
    }
  }, "the shot, as taken"), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeOpacity: 0.55,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 295h44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162 291l8 4-8 4z",
    fill: "#fff",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 291,
    fill: "#FF4D5E",
    style: {
      fontSize: 13
    }
  }, "Gaby"), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178 295h24",
    stroke: "#FF4D5E",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 307,
    fill: "#FF4D5E",
    style: {
      fontSize: 10,
      letterSpacing: "0.06em"
    }
  }, "WRONG PERSON"), /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 362,
    fill: "#fff",
    style: {
      fontSize: 12
    }
  }, "One hat misread, and it is somebody else."), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 386h320",
    stroke: "#fff",
    strokeOpacity: 0.15
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 418,
    fill: "#fff",
    fillOpacity: 0.6,
    style: {
      fontSize: 10,
      letterSpacing: "0.09em"
    }
  }, "WHAT WE ACTUALLY DO"), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 418,
    textAnchor: "end",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fontSize: 10
    }
  }, "three garments apart"), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "tomBottom"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 430,
    width: 44,
    height: 11,
    rx: 3,
    fill: "#4F7468"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 441,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#2E2E2E",
    stroke: "#fff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 465,
    width: 56,
    height: 52,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 465,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 465,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 488,
    width: 17,
    height: 12,
    rx: 2,
    fill: "#AAC634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 518,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 518,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 430,
    width: 44,
    height: 11,
    rx: 3,
    fill: "#2D5170"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 441,
    width: 32,
    height: 22,
    rx: 4,
    fill: "#2E2E2E",
    stroke: "#fff",
    strokeOpacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 465,
    width: 56,
    height: 52,
    rx: 3,
    fill: "#FFF200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 465,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#FFF200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 465,
    width: 13,
    height: 44,
    rx: 3,
    fill: "#FFF200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 488,
    width: 17,
    height: 12,
    rx: 2,
    fill: "#0F61A6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 518,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 518,
    width: 24,
    height: 52,
    rx: 3,
    fill: "#F0EFEA"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 588,
    textAnchor: "middle",
    fill: "#fff",
    style: {
      fontSize: 13
    }
  }, "Tom"), /*#__PURE__*/React.createElement("text", {
    x: 224,
    y: 588,
    textAnchor: "middle",
    fill: "#fff",
    style: {
      fontSize: 13
    }
  }, "Gaby"), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "10.5px"
    }
  }, _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 606,
    fill: "#fff"
  }, "hat green")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 619,
    fill: "#fff"
  }, "t-shirt purple")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 632,
    fill: "#fff"
  }, "armband lime")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 645,
    fill: "#fff",
    fillOpacity: 0.75
  }, "trousers off-white")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 606,
    fill: "#fff"
  }, "hat navy")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 619,
    fill: "#fff"
  }, "t-shirt yellow")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 632,
    fill: "#fff"
  }, "armband blue")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 645,
    fill: "#fff",
    fillOpacity: 0.75
  }, "trousers off-white"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 660,
    width: 104,
    height: 86,
    rx: 3,
    fill: "#0B0B0B",
    stroke: "#fff",
    strokeOpacity: 0.18
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("use", {
    href: "#tomBottom",
    xlinkHref: "#tomBottom",
    filter: "url(#f2blur)",
    transform: "translate(32.7 470.2) scale(0.46)"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 740,
    textAnchor: "middle",
    fill: "#fff",
    fillOpacity: 0.75,
    style: {
      fontSize: "9.5px"
    }
  }, "the same shot"), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeOpacity: 0.55,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118 703h44"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162 699l8 4-8 4z",
    fill: "#fff",
    fillOpacity: 0.55
  })), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 699,
    fill: "#fff",
    style: {
      fontSize: 13
    }
  }, "Tom"), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 715,
    fill: "#fff",
    fillOpacity: 0.6,
    style: {
      fontSize: 10,
      letterSpacing: "0.06em"
    }
  }, "STILL TOM"), /*#__PURE__*/React.createElement("text", {
    x: 6,
    y: 770,
    fill: "#fff",
    style: {
      fontSize: 12
    }
  }, "The same misread, and no doubt about it."));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF2SpotTheDifference);
export default __webpack_public_path__ + "static/media/f2-spot-the-difference.b2cc1cb588b1d182e441a4c47514ac80.svg";
export { ForwardRef as ReactComponent };